module.exports = __webpack_public_path__ + "2f0263e0853b6f2c798368f73ac87cde.svg";